import React, { useState } from 'react'
import { Box, createTheme, Paper, Typography, Switch, Divider, List, ListItem, ListItemText, ListItemButton, ListItemIcon } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check';

const Rates = (props) => {

  const [isAnnual, setIsAnnual] = useState(false);

  const handleSwitch = () => {
    setIsAnnual(!isAnnual);
  } 

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
  });

  const ratesData = [
    {
      level: 1,
      priceAnnually: 0,
      priceMonthly: 0,
      priceSetup: 0,
      features: [
        "Manufacturer provides blocks to Cadsoft specifications",
        "First 5 blocks are free",
      ],
    },
    {
      level: 2,
      priceAnnually: "3,000",
      priceMonthly: "275",
      priceSetup: "5,000",
      features: [
        "Manufacturer provides blocks to Cadsoft specifications",
        "Up to 50 blocks",
        "Blocks can be updated and substituted yearly",
        "Cadsoft provides data analytics regarding block usage",
      ],
    },
    {
      level: 3,
      priceAnnually: "6,000",
      priceMonthly: "575",
      priceSetup: "7,500",
      features: [
        "Manufacturer provides blocks to Cadsoft specifications",
        "Up to 500 blocks (additional fees apply for additional blocks)",
        "Blocks can be updated and substituted yearly",
        "Cadsoft provides data analytics regarding block usage",
        "Link to Manufacturer's website for direct purchase of products",
      ],
    },
    {
      level: 4,
      priceAnnually: "18,000",
      priceMonthly: "1,500",
      priceSetup: "15,000",
      features: [
        "White-label Personal Architect on the manufacturer's website",
        "Manufacturer provides blocks to Cadsoft specifications",
        "Up to 500 blocks on Personal Architect (additional fees apply for additional blocks)",
        "Blocks can be updated and substituted yearly",
        "Cadsoft provides data analytics regarding block usage",
        "Shopping cart integration with Personal Architect",
      ],
    },
  ]

  return (
    <Box>
      <Box sx={{alignItems: "center", display: "flex", justifyContent: "flex-end",}}>
        <Typography fontSize={10} textTransform="uppercase">Monthly</Typography>
        <Switch
          checked={isAnnual}
          onChange={handleSwitch}
          inputProps={{ 'aria-label': 'controlled' }}
        />
        <Typography fontSize={10} textTransform="uppercase">Annually</Typography>
      </Box>
      <Box sx={{display: "flex", flexWrap: "wrap", justifyContent: "center",}}>
        {
          ratesData.map(rate => (
            <Box
              key={rate.level}
              sx={{
                flexBasis: "25%",
                [theme.breakpoints.down('lg')]: {
                  flexBasis: '50%',
                },
                [theme.breakpoints.down('md')]: {
                  flexBasis: '100%',
                },
                [theme.breakpoints.down('sm')]: {
                  flexBasis: "100%",
                },
                p:.5,
              }}
            >
              <Paper>
                <Box sx={{backgroundColor: "#b71c1c", borderTopLeftRadius: "4px", borderTopRightRadius: "4px", height: 10, width: "100%",}}></Box>
                <Box sx={{p: 1,}}>
                  <Box>
                    <Typography component="h2" variant="h6" >Level {rate.level}</Typography>
                  </Box>
                  <Box sx={{alignItems: "baseline", display: "flex",}}>
                    <Typography component="h3" fontWeight={600} variant="h2">${isAnnual ? rate.priceAnnually : rate.priceMonthly}</Typography>
                    <Typography sx={{fontSize: 10, ml: 1,}}>per {isAnnual ? "year" : "month"}</Typography>
                  </Box>
                  <Box>
                    {
                      rate.priceSetup === 0 ?  
                        <Typography fontSize={12}>No Setup Fee</Typography>
                      : 
                        <Typography fontSize={12}>Setup Fee: ${rate.priceSetup}</Typography>
                    }
                  </Box>
                </Box>
                <Box sx={{my:1,}}>
                  <Divider />
                </Box>
                <List dense>
                  {rate.features.map(feature => (
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <CheckIcon />
                        </ListItemIcon>
                        <ListItemText>{feature}</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </Box>
          ))
        }
      </Box>
    </Box>
  )
}

export default Rates